export function toLocalString(timestamp: UnixTimeStamp): LocalDateTimeString {
  return new Date(timestamp).toString();
}
